
import React, { useEffect, useState } from 'react';
import './styledsk.css';
import logo from '../../assets/img/Sobr.png';
import Navbar from '../../components/navbarus';
import arrow from '../../assets/img/arrow.svg';
import midias from '../../assets/img/Social Media.svg';
import { useNavigate } from 'react-router-dom';
import vector6 from '../../assets/img/Vector6.png';

const Privacy = () => {
    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo2');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
    <>
        <header className="header-containerx">
            <div className="header-left">
                <img className='logo2' src={logo} alt="Logo" height='70px' />
            </div>
            <nav className="header-nav">
                <a href="/">Home</a>
                <a href="/ambassadors">Ambassadors</a>
                <a href="/teamsobr">Team Sobr</a>
                <a href="/terms&policy">Terms and Policy</a>
            </nav>
            <div className="header-right">
                <a className='butontranslate' href="/br">pt-BR</a>
                <a className='butontranslate' href="/es">es-ES</a>
            </div>
        </header>

        <body>
            <div className="content16">
                <h1>TÉRMINOS Y CONDICIONES DE USO DE LA APLICACIÓN MÓVIL "SOBR" CON CONSENTIMIENTO PARA LA RECOLECCIÓN Y USO DE DATOS</h1>
                <p>
                    Estos términos y condiciones se aplican al uso de la aplicación móvil "SOBR", proporcionada por Sobr Inc., una empresa debidamente registrada bajo el EIN: 32-0785960, con sede en 1021 E Lincolnway, 7372, Cheyenne, WY 82001, en su sitio web y plataforma "SOBR", disponible en el sitio web https://www.sobr.app y sus subdominios. Para todos los efectos legales, la Política de Privacidad es parte inseparable de estos Términos de Uso, la cual puede ser consultada en el siguiente enlace: https://www.sobr.app/politica-de-privacidad.

                    En caso de dudas, solicitudes o más información, el USUARIO puede contactar a Sobr Inc. a través del correo electrónico: contact@sobr.app.
                </p>
            </div>
            <div className="content16">
                <h2>ACEPTACIÓN DE LOS TÉRMINOS DE USO Y CONSENTIMIENTO PARA LA RECOLECCIÓN Y USO DE DATOS</h2>
                <p>
                    El uso de la plataforma o del contenido expuesto en ella somete al USUARIO a la observancia y respeto de las condiciones detalladas a continuación. En caso de no estar de acuerdo, no se recomienda el uso de la aplicación.
                    Al acceder o utilizar la aplicación móvil "SOBR" ("Aplicación") proporcionada por Sobr Inc. ("nosotros", "nuestro", "Sobr"), el USUARIO acepta y se somete a estos Términos de Uso y da su consentimiento para la recolección y uso de datos conforme a lo descrito en estos términos.
                </p>
            </div>
            <div className="content16">
                <h2>CAMBIOS EN LOS TÉRMINOS DE USO Y CONSENTIMIENTO PARA LA RECOLECCIÓN Y USO DE DATOS</h2>
                <p>
                    Nos reservamos el derecho de modificar, alterar, reemplazar o actualizar estos Términos y Condiciones, incluyendo las disposiciones relacionadas con la recolección y uso de datos, en cualquier momento y a nuestra discreción, siempre con el objetivo de mejorar la experiencia del usuario.
                    Todas las modificaciones entrarán en vigor inmediatamente después de su publicación, y el usuario será notificado de los términos modificados. Al continuar utilizando nuestra aplicación, el usuario acepta los Términos modificados.
                </p>
            </div>
            <div className="content16">
                <h2>CONSENTIMIENTO PARA LA RECOLECCIÓN Y USO DE DATOS</h2>
                <p>
                    Al utilizar la Aplicación, el usuario consiente expresamente en la recolección, almacenamiento y procesamiento de datos personales y/o no personales, como se describe en nuestra Política de Privacidad.
                    El usuario comprende y consiente que ciertas funcionalidades de la Aplicación pueden requerir la recolección y procesamiento de datos personales para ofrecer servicios específicos.
                    Sobr Inc. puede utilizar estos datos para la monitorización del servicio, análisis y mejoras de la aplicación.
                </p>
            </div>
            <div className="content16">
                <h2>ELEGIBILIDAD</h2>
                <p>
                    Sobr es una plataforma de relaciones cuyo objetivo es conectar a personas sobrias.
                    La aplicación está destinada a la comunicación en línea entre miembros adultos y no es adecuada para menores de 18 años. Al utilizar la aplicación, el usuario confirma tener al menos 18 años.
                    Si el usuario tiene una condena pendiente o está sujeto a alguna orden judicial relacionada con agresión, violencia, conducta sexual inapropiada o acoso, no podrá usar la aplicación y su cuenta será bloqueada o eliminada.
                    Si el usuario es removido de la aplicación, no podrá volver a utilizarla. En caso de ser removido, no se reembolsará sus pagos y su suscripción será interrumpida.
                    Nos reservamos el derecho de alterar, suspender o descontinuar cualquier aspecto del servicio en cualquier momento, sin previo aviso o responsabilidad.
                </p>
            </div>
            <div className="content16">
                <h2>CUENTA DEL USUARIO Y DATOS PERSONALES</h2>
                <p>
                    Para utilizar la aplicación, es necesario que el usuario se registre.
                    El usuario consiente en la recolección de información personal necesaria durante el proceso de registro y uso de la Aplicación, como se detalla en nuestra Política de Privacidad.
                    El usuario se compromete a proporcionar información actual, completa y precisa al crear su cuenta y a mantenerla actualizada.
                    El usuario es responsable de la privacidad de su contraseña, información y contenido publicado o compartido en la Aplicación, así como de sus interacciones con otros usuarios.
                    El usuario acepta que la cuenta es solo para uso personal y no puede ser utilizada por terceros. Nos reservamos el derecho de bloquear o remover contenido inapropiado.
                </p>
            </div>
            <div className="content16">
                <h2>RESTRICCIONES DE INFORMACIÓN Y CONTENIDO</h2>
                <p>
                    El USUARIO no publicará ni compartirá información o contenido en la aplicación que:
                    a) Intente acosar, amenazar o intimidar a otros usuarios.
                    b) Sea difamatorio, abusivo, ofensivo o explícitamente sexual.
                    c) Promueva el racismo, odio o daño físico.
                    d) Fomente actividades ilegales.
                    e) Contengan mensajes publicitarios no solicitados o spam.
                    f) Incluya imágenes de menores de 18 años o de otra persona sin su consentimiento.
                    g) Sea falso o pretenda suplantar a otra persona o entidad.
                    h) Viole los derechos de propiedad intelectual de terceros.
                    Nos reservamos el derecho de emitir advertencias, suspender o eliminar cuentas si se infringen estos términos.
                </p>
            </div>
            <div className="content16">
                <h2>RIESGOS Y PRECAUCIONES</h2>
                <p>
                    Sobr Inc. no realiza verificaciones de antecedentes penales de los usuarios.
                    El usuario es responsable de tomar las precauciones de seguridad necesarias al interactuar en línea o fuera de línea con otros miembros.
                    Sobr Inc. no garantiza la precisión de la información proporcionada por otros usuarios y cualquier confianza en dicha información es bajo su propio riesgo.
                </p>
            </div>
            <div className="content16">
                <h2>DENUNCIAS Y PROBLEMAS</h2>
                <p>
                    El USUARIO puede denunciar cualquier comportamiento que viole estos Términos escribiendo a contact@sobr.app.
                    Sobr Inc. no está obligada a intervenir en disputas privadas entre miembros.
                </p>
            </div>
            <div className="content16">
                <h2>DERECHOS DE PROPIEDAD INTELECTUAL</h2>
                <p>
                    Sobr Inc. es propietaria exclusiva de todos los derechos de propiedad intelectual relacionados con el diseño, contenido y software de la aplicación.
                    La aplicación está destinada exclusivamente para uso personal y no comercial.
                </p>
            </div>
            <div className="content16">
                <h2>LIMITACIÓN DE RESPONSABILIDAD</h2>
                <p>
                    Sobr Inc. proporcionará el servicio con la habilidad y cuidado razonables. No garantizamos la precisión del contenido ni del servicio.
                    Sobr Inc. y sus afiliados no serán responsables por daños derivados del uso del servicio, incluyendo lesiones personales, pérdida de negocios o lucro cesante. El uso de la aplicación es bajo el propio riesgo del usuario.
                </p>
            </div>
            <div className="content16">
                <h2>SUSCRIPCIÓN DE MIEMBRO</h2>
                <p>
                    Sobr podrá ofrecer servicios de suscripción mediante compras en la aplicación. El usuario autoriza a Sobr o a terceros a cobrar automáticamente a su método de pago.
                    Si el usuario desea modificar o cancelar su suscripción, deberá hacerlo a través de la configuración de su cuenta. La eliminación de la cuenta no cancela automáticamente la suscripción.
                </p>
            </div>
            <div className="content16">
                <h2>OBJETOS VIRTUALES</h2>
                <p>
                    Con el tiempo, puede adquirir o ganar una licencia limitada, personal, intransferible, no sublicenciable y revocable para usar "objetos virtuales", que pueden incluir productos virtuales o "monedas", u otras unidades intercambiables dentro del Servicio para productos virtuales (colectivamente, "Objetos Virtuales"). Cualquier saldo de Objetos Virtuales que se muestre en su cuenta no constituye un saldo del mundo real ni refleja ningún valor almacenado, sino que constituye una medida del alcance de su licencia.
                    Los Objetos Virtuales no incurren en tarifas por no uso, sin embargo, la licencia que se le otorga en los Objetos Virtuales terminará de acuerdo con los términos de este Acuerdo cuando Sobr deje de proporcionar el Servicio o su cuenta sea cerrada o terminada.
                </p>
            </div>
            <div className="content16">
                <h2>REEMBOLSOS</h2>
                <p>
                    En general, los cargos por compras no son reembolsables, y no hay reembolsos ni créditos por períodos parcialmente utilizados. Podemos hacer una excepción si se solicita un reembolso para una oferta de suscripción dentro de los 14 días posteriores a la fecha de la transacción, o si las leyes aplicables en su jurisdicción proporcionan opciones de reembolso.
                </p>
            </div>
            <div className="content16">
                <h2>PARA SOLICITAR UN REEMBOLSO:</h2>
                <p>
                    Si realiza una compra usando su Apple ID, los reembolsos serán realizados por Apple, no por Sobr. Para solicitar un reembolso, vaya a la App Store, haga clic en su Apple ID, seleccione "Historial de compras", localice la transacción y haga clic en "Informar un problema". El usuario también puede enviar una solicitud a https://getsupport.apple.com.
                </p>
            </div>
            <div className="content16">
                <h2>PRECIOS</h2>
                <p>
                    Sobr opera un negocio global, y nuestros precios varían según varios factores. A menudo ofrecemos precios promocionales, que pueden variar según la región, la duración de la suscripción, el tamaño del paquete y otros factores. También probamos regularmente nuevas funciones y opciones de pago.
                </p>
            </div>
            <div className="content16">
                <h2>PRIVACIDAD Y SEGURIDAD DE DATOS</h2>
                <p>
                    Su uso de la Aplicación está sujeto a nuestra Política de Privacidad, que detalla cómo recopilamos, usamos y protegemos sus datos personales. Es importante que el usuario lea y comprenda nuestra Política de Privacidad.
                </p>
            </div>
            <div className="content16">
    <h2>DERECHOS DEL TITULAR DE LOS DATOS</h2>
    <p>
    De acuerdo con la LGPD, el usuario tiene derechos relacionados con sus datos personales, incluidos los derechos de acceso, corrección y eliminación de sus datos. Para ejercer estos derechos o si tiene preguntas sobre la protección de datos, contáctenos en @contact@sobr.app.
    </p>
</div>
<div className="content16">
    <h2>DISPOSICIONES GENERALES</h2>
    <p>
    Estos Términos de Uso y el Consentimiento para la Recolección y Uso de Datos conforme a la LGPD constituyen el acuerdo completo entre el usuario y Sobr con relación a la Aplicación. La falta de ejercicio o ejecución de cualquier derecho o disposición de estos Términos de Uso por parte de Sobr no constituirá una renuncia a dicho derecho o disposición.
Sobr Inc. puede ser adquirida parcial o completamente por otra empresa, sin previo aviso (por escrito).
Si alguna parte de estos términos está prohibida o es declarada nula por cualquier tribunal o regulador, las demás disposiciones continuarán aplicándose. Ajustaremos estos Términos según sea necesario, y en ese caso, los términos inválidos serán reemplazados por términos válidos que sean lo menos diferentes posible de los términos inválidos en cuestión.
Estos Términos no están destinados a otorgar derechos a nadie, excepto al usuario y a Sobr Inc.
Estos Términos se rigen por la ley brasileña y las partes acuerdan someterse a la jurisdicción exclusiva del tribunal de Río de Janeiro.
    </p>
</div>
<div className="content16">
    <h2>CONTACTO</h2>
    <p>
    Si tiene alguna pregunta sobre los Términos de Uso, el Consentimiento para la Recolección y Uso de Datos conforme a la LGPD o la protección de datos, por favor contáctenos en:
Centro de Contacto de Sobr: contact@sobr.app

Al usar la Aplicación, usted declara que ha leído, entendido y aceptado estos Términos de Uso, ha dado su consentimiento para la recolección y uso de sus datos personales de acuerdo con la LGPD y ha aceptado nuestra Política de Privacidad.
    </p>
</div>
<div className="content16">
    <h2>¡Bienvenido!</h2>
    <p>
    En Sobr, valoramos su privacidad y estamos comprometidos con la protección de sus datos personales. Por lo tanto, presentamos esta Política de Privacidad para informarle cómo utilizamos su información personal.
    </p>
</div>
<div className="content17">
    <h2>¿QUÉ HACE SOBR INC.?</h2>
    <p>
    Operamos principalmente en las siguientes áreas comerciales:
    Desarrollo de software personalizado;
    Desarrollo y licencia de software personalizable.
    </p>
</div>
<div className="content17">
    <h2>¿CÓMO PROCESA SOBR INC. LOS DATOS?</h2>
    <p>
    Como cualquier empresa, para llevar a cabo nuestras actividades, necesitamos recopilar y procesar cierta información que la ley considera datos personales. Para mantenerlo informado sobre cómo procesamos estos datos, hemos preparado el siguiente resumen con las preguntas más comunes que puede tener. Para obtener información más detallada, haga clic en "Leer más" en la sección correspondiente a continuación.
    </p>
</div>
<div className="content18">
    <h2>1. ¿QUÉ DATOS PERSONALES RECOPILAMOS?</h2>
    <p>
    Recopilamos los siguientes datos personales, pero no se limitan a:
    Nombre;
    Fecha de nacimiento;
    Dirección comercial;
    Correo electrónico;
    Número de teléfono/celular;
    Información de pago;
    Perfiles de redes sociales;
    Dirección residencial.
    Además, podemos usar sus datos personales en forma anonimizada (es decir, de manera que no permita identificar a ningún individuo), con el propósito de generar informes de inteligencia empresarial analítica para mejorar y mantener la seguridad de nuestros servicios.
    </p>
</div>
<div className="content19">
    <h2>2. ¿POR QUÉ USAMOS DATOS PERSONALES?</h2>
    <p>
    Utilizamos datos personales para fines relacionados con la prestación de nuestros servicios, lo que incluye:
    -Personalización de la experiencia del usuario;
    -Mantenimiento y gestión de registros;
    -Publicidad y marketing;
    -Garantizar el acceso a la plataforma;
    -Análisis e investigación de mercado;
    -Cumplimiento y resolución de disputas;
    -Contactar a los usuarios;
    -Concursos y promociones;
    -Reclutamiento y selección.
    </p>
</div>
<div className="content20">
    <h2>3. ¿CON QUIÉN COMPARTIMOS DATOS PERSONALES?</h2>
    <p>
    Podemos compartir datos personales con las siguientes partes:
    Socios de verificación de identidad: Para mejorar la eficiencia de vincular nuestros identificadores con otros, podemos compartir identificadores con socios, como intermediarios de pago.
    Socios de prevención de fraudes: Para permitir que los socios detecten fraudes de manera efectiva, compartimos ciertos datos personales según sea necesario.
    Autoridades públicas u organismos oficiales: Para cumplir con obligaciones legales, podemos compartir datos con autoridades públicas o organismos oficiales previa solicitud o mandato legal.
    En cualquier caso, el procesamiento de datos será de acuerdo con las leyes aplicables y limitado a lo necesario para cumplir con las obligaciones contractuales.
    </p>
</div>
<div className="content21">
    <h2>4. CANCELACIÓN DE LA CUENTA</h2>
    <p>
        1. Los usuarios pueden cancelar su cuenta a través de configuraciones disponibles en la plataforma.
        <br />
        2. Al cancelar, los datos del usuario serán clasificados como "cancelados" para permitir la posible reactivación de la cuenta en el futuro.
        <br />
        3. El proceso de cancelación será transparente y fácil de navegar, garantizando que los usuarios comprendan los pasos e implicaciones.
    </p>
</div>
<div className="content22">
    <h2>5. REVOCACIÓN DEL COMPARTO DE INFORMACIÓN</h2>
    <p>
        1. Cuando la cuenta es cancelada, cualquier compartición de información personal con terceros será revocada automáticamente.
        <br />
        2. Sobr informará al usuario qué información dejará de compartirse y qué datos se retendrán después de la cancelación.
    </p>
</div>
<div className="content23">
    <h2>6. ELIMINACIÓN DE DATOS</h2>
    <p>
        1. Los usuarios pueden solicitar la eliminación de sus datos personales en cualquier momento enviando un correo electrónico a contact@sobr.app.
        <br />
        2. Sobr se compromete a responder a dichas solicitudes dentro de una semana a partir de su recepción.
        <br />
        3. El proceso de eliminación incluirá los pasos necesarios y cualquier procedimiento de verificación para garantizar la seguridad y autenticidad de la solicitud.
    </p>
</div>
<div className="content24">
    <h2>POLÍTICA DE COOKIES</h2>
    <h2>¿QUÉ SON LAS COOKIES?</h2>
    <p>
    Las cookies son archivos digitales que contienen pequeñas porciones de datos (generalmente con un identificador único) que se almacenan en el dispositivo del usuario. Pueden ser temporales (se eliminan automáticamente al cerrar el navegador o la aplicación) o persistentes (se almacenan en el dispositivo hasta una fecha de expiración definida). Las cookies pueden ser establecidas por la propia plataforma (cookies de primera parte) o por terceros (cookies de terceros).
    </p>
</div>
<div className="content25">
    <h2>¿POR QUÉ USAMOS COOKIES?</h2>
    <p>
    Las cookies mejoran la experiencia del usuario al optimizar el rendimiento y la usabilidad de la plataforma, recordando preferencias del usuario como idioma, ubicación, recurrencia de la sesión y otras variables. Las cookies también pueden recopilar datos estadísticos anónimos para ayudarnos a comprender cómo los usuarios interactúan con la plataforma y mejorar su estructura y contenido.
    </p>
    <h2>¿QUÉ TIPOS DE COOKIES USAMOS?</h2>
</div>
<div className="content26">
    <p>
    Cookies esenciales: Necesarias para el correcto funcionamiento de nuestra plataforma, recordando acciones como entradas previas al navegar entre páginas en una sesión.
    Cookies de rendimiento y análisis: Nos ayudan a comprender cómo interactúan los usuarios con nuestra plataforma, medir el tamaño de la audiencia y analizar el comportamiento de navegación.
    Cookies publicitarias: Hacen que los anuncios sean más relevantes para los usuarios, garantizando que no aparezcan repetidamente y, en algunos casos, seleccionando anuncios en función de los intereses del usuario.
    Cookies de redes sociales: Permiten a los usuarios compartir contenido de nuestro sitio a través de redes sociales.
    </p>
</div>
<div className="content30">
    <h2>Para preguntas o inquietudes sobre esta política, contáctenos en: contact@sobr.app</h2>
</div>
                <footer>
                    <div className="footer-contentdsk">
                        <p>Términos de Servicio | Política de Privacidad</p>
                    </div>
                    <div className="footer-copyrightdsk">
                        &copy; 2024 Sobr Inc. Todos los derechos reservados
                    </div>
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>
            </body>
    </>
        );
    };
export default Privacy;
